import { FilterKey } from "@studyportals/search-filters";
import { RouteFilter } from "../RouteFilter";
import { RouteFragmentDetails } from "../RouteFragmentDetails";
import { RouteParams } from "../RouteParams";
import { DisciplinePresenter } from "@/presenters/DisciplinePresenter";
import { SortingOptions } from "@/sorting/SortingOptions";
import { RouteFragment } from "../RouteFragment";
import { IEmbeddedState } from "@/url/IEmbeddedState";

export class RouteDiscipline extends RouteFilter {

	public static readonly fragmentType: typeof RouteDiscipline = RouteDiscipline;
	private readonly sortingOption: SortingOptions;

	public constructor() {
		super(
			'Discipline',
			FilterKey.DISCIPLINES,
			new RouteFragmentDetails(RouteParams.DISCIPLINE, DisciplinePresenter.allWithPaths()),
		);

		this.sortingOption = SortingOptions.UNIVERSITY_META_RANKING;
	}

	public instantiate(): RouteFragment {
		return new RouteDiscipline();
	}

	protected override async selfSupports(embeddedState: IEmbeddedState): Promise<boolean> {
		const selected = embeddedState.filterSelectionState.reactive.getFor(this.key);
		const isSortedBy = embeddedState.sortingState.isSelected(this.sortingOption);

		return isSortedBy && selected.length === 1 && (await this.fragmentDetails.supports(selected[0]));
	}
}